module.exports = __webpack_public_path__ + "images/questions/qa_best_answer_label_2b03b8923dfc73177502efb5993d3f1b.png";